const ROLES = [
  {
    n: "01",
    title: "Branding",
    blurb:
      "Identity systems engineered for gravity. Marks, voice, and worldview that make brands impossible to ignore.",
  },
  {
    n: "02",
    title: "Creative Technology",
    blurb:
      "UX, UI, code, motion, and visual art collapsed into one practice. I design and ship — no hand-offs, no compromises.",
  },
  {
    n: "03",
    title: "Author",
    blurb:
      "Author of The Butterfly Effect & Think Differently. Small strategic shifts, massive transformations — with the framework to back it.",
  },
  {
    n: "04",
    title: "Investor",
    blurb:
      "Backing founders brave enough to think differently. Capital, structure, and a seat at the war-room table.",
  },
  {
    n: "05",
    title: "Mentor",
    blurb:
      "One-on-one operator coaching for builders in the messy middle. Strategy, taste, and the unfair advantages I wish I had earlier.",
  },
  {
    n: "06",
    title: "Collector",
    blurb:
      "Global currency, rare books, and obsessions worth keeping. Every artifact a window into a world I'm still learning from.",
  },
];

export default function Roles() {
  return (
    <section
      id="roles"
      data-testid="roles-section"
      className="relative py-16 md:py-32 border-t border-white/10"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-white/10 grid-skel">
          {ROLES.map((r) => (
            <article
              key={r.n}
              data-testid={`role-card-${r.n}`}
              className="group relative p-6 md:p-10 min-h-[240px] md:min-h-[300px] flex flex-col justify-between transition-colors hover:bg-white/[0.02] overflow-hidden"
            >
              <span
                aria-hidden
                className="number-3d absolute top-2 right-3 md:top-4 md:right-6 font-display font-black text-[7rem] md:text-[10rem] leading-none tracking-tighter select-none pointer-events-none"
              >
                {r.n}
              </span>

              <div className="relative flex items-start justify-between">
                <span className="font-mono text-[10px] tracking-[0.3em] text-white/30 uppercase">
                  / Role · {r.n}
                </span>
              </div>

              <div className="relative">
                <h3
                  className="metal-blue font-display text-2xl md:text-4xl font-black mb-2 md:mb-3 leading-[0.95] tracking-tight"
                  data-testid={`role-title-${r.n}`}
                >
                  {r.title}
                </h3>
                <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-md">
                  {r.blurb}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

